import React, { FC } from 'react'
import { useLocation, Link } from 'react-router-dom'
import cx from 'classnames'
import styles from './MenuItem.module.scss'

type MenuItemProps = {
  children: React.ReactElement
  path?: string
}

export const MenuItem: FC<MenuItemProps> = (props) => {
  const location = useLocation()

  const classes = cx({
    [styles.menuItem]: styles.menuItem,
    [styles.active]: props.path === location.pathname,
  })

  const Element: any = props.path ? Link : 'div'
  const Element1: any = 'a'

  if (props.path === "/dashboard") {

    var url = String(window.location);
    var urlbool = url.includes("app");
    var url2 = null;

    if (urlbool) {
      url2 = "https://app.descifra.global/dashboard"
    } else {
      url2 = "https://staging.descifra.global/dashboard"
    }

    return (<Element1 href={url2} className={classes}>
      {props.children}
    </Element1>)

  } else {
    return (
      <Element className={classes} {...(props.path ? { to: props.path } : null)}>
        {props.children}
      </Element>
    )
  }

}


MenuItem.displayName = 'MenuItem'
